import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

type Variant = 'default' | 'success' | 'warning' | 'error' | 'info' | 'ai';

const variants: Record<Variant, string> = {
  default: 'bg-slate-100 text-slate-700',
  success: 'bg-success-50 text-success-700',
  warning: 'bg-warning-50 text-warning-700',
  error: 'bg-error-50 text-error-700',
  info: 'bg-info-50 text-info-700',
  ai: 'bg-ai-50 text-ai-700',
};

type Props = { variant?: Variant; children: ReactNode; className?: string };

export function Badge({ variant = 'default', children, className }: Props) {
  return (
    <span className={cn('inline-flex rounded-full px-2 py-0.5 text-xs font-medium', variants[variant], className)}>
      {children}
    </span>
  );
}

export function StatusChip({ status }: { status: string }) {
  const s = status.toLowerCase();
  let variant: Variant = 'default';
  if (['enabled', 'active', 'paid', 'matched', 'completed', 'approved', 'success'].some((x) => s.includes(x))) variant = 'success';
  else if (['pending', 'draft', 'paused', 'investigating', 'at_risk'].some((x) => s.includes(x))) variant = 'warning';
  else if (['failed', 'error', 'mismatch', 'open', 'critical'].some((x) => s.includes(x))) variant = 'error';
  return <Badge variant={variant}>{status.replace(/_/g, ' ')}</Badge>;
}
